import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

const FieldDatePicker = (props) => {
  const { label, touched, errors, setFieldValue, fieldName, values } = props;

  React.useEffect(() => {
    if (values[fieldName] != null) {
      setFieldValue(fieldName, values[fieldName]);
    }
  }, []);

  return (
    <Wrapper>
      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
        <DatePicker
          clearable
          okLabel="تأیید"
          cancelLabel="لغو"
          clearLabel="پاک کردن"
          inputVariant="outlined"
          label={label}
          fullWidth
          labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
          value={values[fieldName]}
          onChange={(e) => {
            setFieldValue(fieldName, e);
          }}
          error={touched[fieldName] && Boolean(errors[fieldName])}
          helperText={touched[fieldName] && errors[fieldName]}
        />
      </MuiPickersUtilsProvider>
    </Wrapper>
  );
};

export default React.memo(FieldDatePicker);
